module.exports = __webpack_public_path__ + "img/kintetsu_tc2.ccd6d6fa.jpg";